import React from "react";
import { Form } from "@components";
import { Wrapper } from "../wrapper";

export type WinscpFormValues = {
  country1: boolean;
  country2: boolean;
  country3: boolean;
  country4: boolean;
  country5: boolean;
  country6: boolean;
  country7: boolean;
  country8: boolean;
  country9: boolean;
  country10: boolean;
};

type Props = {
  title: string;
  onCancel: () => void;
  onSubmit: (values: WinscpFormValues) => void;
  open: boolean;
  values: Partial<WinscpFormValues>;
  readonly?: boolean;
};

export const WinscpForm: React.FC<Props> = ({
  title,
  onCancel,
  onSubmit,
  open,
  values,
  readonly,
}) => {
  const form = Form.useManager<WinscpFormValues>({
    country1: false,
    country2: false,
    country3: false,
    country4: false,
    country5: false,
    country6: false,
    country7: false,
    country8: false,
    country9: false,
    country10: false,
    ...values,
  });

  function onFormValueChange(
    name: keyof WinscpFormValues,
    value: WinscpFormValues[typeof name]
  ): void {
    form.set(Form.target.VALUE, [name, value]);
    form.set(Form.target.ERROR, ["country1", undefined]);
  }

  function onFormSubmit(): void {
    validate().then(([name, error]) => {
      if (!error) {
        onSubmit(form.values);
      } else {
        form.set(Form.target.ERROR, [name, error]);
      }
    });
  }

  function validate(): Promise<["country1", Error?]> {
    let error;
    if (Object.values(form.values).every((value) => value === false)) {
      error = new Error("Select at least one");
    }

    return Promise.resolve(["country1", error]);
  }

  return (
    <Wrapper
      onCancel={() => {
        onCancel();
        if (values) {
          form.set(Form.target.VALUES, values);
        } else {
          form.reset();
        }
      }}
      onSubmit={onFormSubmit}
      open={open}
      size="sm"
      title={title.split("(")[0]}
      readonly={readonly}
    >
      <Form>
        <Form.Title error={form.errors.country1}>
          1. Please select relevant countries
        </Form.Title>
        <Form.Checkbox
          label="Brunei"
          name="country1"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country1}
        />
        <Form.Checkbox
          label="Malaysia"
          name="country6"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country6}
        />
        <Form.Checkbox
          label="China"
          name="country2"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country2}
        />
        <Form.Checkbox
          label="Philippines"
          name="country7"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country7}
        />
        <Form.Checkbox
          label="Hong Kong"
          name="country3"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country3}
        />
        <Form.Checkbox
          label="Singapore"
          name="country8"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country8}
        />
        <Form.Checkbox
          label="India"
          name="country4"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country4}
        />
        <Form.Checkbox
          label="Sri Lanka"
          name="country9"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country9}
        />
        <Form.Checkbox
          label="Macau"
          name="country5"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country5}
        />
        <Form.Checkbox
          label="Maldives"
          name="country10"
          onChange={onFormValueChange}
          size={6}
          value={form.values.country10}
        />
      </Form>
    </Wrapper>
  );
};
